module.exports = __webpack_public_path__ + "img/ic-popup-close.01e846e3.svg";